import { useEffect } from "react";

export const useEditorDerivedUsageIds = ({
  layerCompData,
  claimsArray,
  droppedComponentIds,
  droppedTextIds,
  reusableTextIdsArray,
  droppedTitleIds,
  setClaimsArray,
  setDroppedComponentIds,
  setDroppedTextIds,
  setReusableTextIdsArray,
  setDroppedTitleIds,
}) => {
  useEffect(() => {
    const validClaimIds = layerCompData
      ?.filter((item) => item.claimId)
      ?.map((item) => item.claimId);
    const validComponentIds = layerCompData
      ?.filter((item) => item.componentId)
      ?.map((item) => item.componentId);
    const validTextIds = layerCompData
      ?.filter((item) => item.matchTextId)
      ?.map((item) => item.matchTextId);
    const validReusableText = layerCompData
      ?.filter((item) => item.reusableTextId)
      ?.map((item) => item.reusableTextId);
    const validTitle = layerCompData
      ?.filter((item) => item.titleId)
      ?.map((item) => item.titleId);

    const claimsInScroll = layerCompData
      ?.filter((item) => item.componentType === "Scrollbar")
      .flatMap((item) => item.scrollbarComponents || [])
      .filter((subItem) => subItem.claimId)
      .map((subItem) => subItem.claimId);

    const componentInScroll = layerCompData
      ?.filter((item) => item.componentType === "Scrollbar")
      .flatMap((item) => item.scrollbarComponents || [])
      .filter((subItem) => subItem.componentId)
      .map((subItem) => subItem.componentId);

    const textInScroll = layerCompData
      ?.filter((item) => item.componentType === "Scrollbar")
      .flatMap((item) => item.scrollbarComponents || [])
      .filter((subItem) => subItem.matchTextId)
      .map((subItem) => subItem.matchTextId);

    const resusableTextInScroll = layerCompData
      ?.filter((item) => item.componentType === "Scrollbar")
      .flatMap((item) => item.scrollbarComponents || [])
      .filter((subItem) => subItem.reusableTextId)
      .map((subItem) => subItem.reusableTextId);

    const titleInScroll = layerCompData
      ?.filter((item) => item.componentType === "Scrollbar")
      .flatMap((item) => item.scrollbarComponents || [])
      .filter((subItem) => subItem.titleId)
      .map((subItem) => subItem.titleId);

    const uniqueValidClaimIds = Array.from(
      new Set([...validClaimIds, ...claimsInScroll]),
    );
    const uniqueValidComponentIds = Array.from(
      new Set([...validComponentIds, ...componentInScroll]),
    );
    const uniqueValidTextIds = Array.from(
      new Set([...validTextIds, ...textInScroll]),
    );
    const uniqueValidResusableTextIds = Array.from(
      new Set([...validReusableText, ...resusableTextInScroll]),
    );
    const uniqueTitle = Array.from(new Set([...validTitle, ...titleInScroll]));

    if (JSON.stringify(claimsArray) !== JSON.stringify(uniqueValidClaimIds)) {
      setClaimsArray(uniqueValidClaimIds);
    }

    if (
      JSON.stringify(droppedComponentIds) !==
      JSON.stringify(uniqueValidComponentIds)
    ) {
      setDroppedComponentIds(uniqueValidComponentIds);
    }

    if (JSON.stringify(droppedTextIds) !== JSON.stringify(uniqueValidTextIds)) {
      setDroppedTextIds(uniqueValidTextIds);
    }

    if (
      JSON.stringify(reusableTextIdsArray) !==
      JSON.stringify(uniqueValidResusableTextIds)
    ) {
      setReusableTextIdsArray(uniqueValidResusableTextIds);
    }

    if (JSON.stringify(droppedTitleIds) !== JSON.stringify(uniqueTitle)) {
      setDroppedTitleIds(uniqueTitle);
    }
  }, [layerCompData]);
};
